export default __webpack_public_path__ + "./image/e78cba1b124989aa6343813daa692c39.png";